export enum ViolationsCustomViewKey {
  overSharedResources = 'overSharedResources',
  nonCompliantConnections = 'nonCompliantConnections',
  insecureCommunication = 'insecureCommunication',
  authenticationIssues = 'authenticationIssues',
  customCode = 'customCode',
  potentiallyRiskyDataFlow = 'potentiallyRiskyDataFlow',
  suspiciousConfiguration = 'suspiciousConfiguration',
  untrustedGuestAccess = 'untrustedGuestAccess',
  untrustedMemberAccess = 'untrustedMemberAccess',
}

export const ViolationsCustomViewFields: {
  [key in ViolationsCustomViewKey]: string;
} = {
  [ViolationsCustomViewKey.overSharedResources]:
    'tableActionsAndFilters.violationsCustomViewDetails.overSharedResources',
  [ViolationsCustomViewKey.nonCompliantConnections]:
    'tableActionsAndFilters.violationsCustomViewDetails.nonCompliantConnections',
  [ViolationsCustomViewKey.insecureCommunication]:
    'tableActionsAndFilters.violationsCustomViewDetails.insecureCommunication',
  [ViolationsCustomViewKey.authenticationIssues]:
    'tableActionsAndFilters.violationsCustomViewDetails.authenticationIssues',
  [ViolationsCustomViewKey.customCode]: 'tableActionsAndFilters.violationsCustomViewDetails.customCode',
  [ViolationsCustomViewKey.potentiallyRiskyDataFlow]:
    'tableActionsAndFilters.violationsCustomViewDetails.potentiallyRiskyDataFlow',
  [ViolationsCustomViewKey.suspiciousConfiguration]:
    'tableActionsAndFilters.violationsCustomViewDetails.suspiciousConfiguration',
  [ViolationsCustomViewKey.untrustedGuestAccess]:
    'tableActionsAndFilters.violationsCustomViewDetails.untrustedGuestAccess',
  [ViolationsCustomViewKey.untrustedMemberAccess]:
    'tableActionsAndFilters.violationsCustomViewDetails.untrustedMemberAccess',
};
